import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { posts } from '../data/posts';
import BlogLayout from '../components/BlogLayout';

export default function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  const post = posts.find(p => p.slug === slug);

  useEffect(() => {
    if (post) document.title = `${post.title} | Evolve Media Agency`;
    window.scrollTo(0, 0);
    const link = document.querySelector("link[rel='canonical']") || document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', `https://evolvemediaagency.com/blog/${slug}`);
    if (!document.querySelector("link[rel='canonical']")) document.head.appendChild(link);
  }, [post, slug]);

  if (!post) {
    return (
      <BlogLayout>
      <div style={{ fontFamily: 'Montserrat, sans-serif', textAlign: 'center', padding: '120px 24px' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '16px' }}>Post not found</h1>
        <Link to="/blog" style={{ color: '#01c61f', fontWeight: 700, textDecoration: 'none' }}>← Back to Blog</Link>
      </div>
      </BlogLayout>
    );
  }

  return (
    <BlogLayout>
    <div style={{ fontFamily: 'Montserrat, sans-serif', color: '#1a1a1a' }}>
      {/* Header */}
      <div style={{ background: '#000', padding: '48px 24px 40px' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <Link to="/blog" style={{ color: '#aaa', fontSize: '14px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px', marginBottom: '24px' }}>
            ← Back to Blog
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <span style={{ background: post.categoryColor, color: '#fff', padding: '4px 14px', borderRadius: '9999px', fontSize: '13px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.5px' }}>
              {post.category}
            </span>
            <span style={{ color: '#888', fontSize: '14px' }}>{post.date}</span>
            <span style={{ color: '#888', fontSize: '14px' }}>·</span>
            <span style={{ color: '#888', fontSize: '14px' }}>{post.readTime}</span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '48px 24px 80px' }}>
        {post.heroImage && (
          <figure className="my-8 rounded-xl overflow-hidden">
            <img
              src={post.heroImage}
              alt={post.heroAlt || post.title}
              className="w-full h-64 md:h-96 object-cover"
              loading="lazy"
            />
            {post.heroCredit && (
              <figcaption className="text-xs text-muted-foreground text-right mt-1 pr-2">
                Photo: {post.heroCredit}
              </figcaption>
            )}
          </figure>
        )}
        <div
          dangerouslySetInnerHTML={{ __html: post.content }}
          style={{ lineHeight: 1.8, fontSize: '1.05rem' }}
        />

        {/* Post CTA */}
        <div style={{ background: '#000', borderRadius: '16px', padding: '40px', marginTop: '64px', textAlign: 'center', color: '#fff' }}>
          <p style={{ color: '#01c61f', fontWeight: 800, fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase', margin: '0 0 12px' }}>FREE RESOURCE</p>
          <h3 style={{ fontWeight: 900, fontSize: '1.6rem', margin: '0 0 16px' }}>Want Step-by-Step Playbooks?</h3>
          <p style={{ color: '#aaa', fontSize: '1rem', maxWidth: '440px', margin: '0 auto 28px', lineHeight: 1.7 }}>
            The free Ecom Profit Box includes 10 guides for Amazon sellers covering launches, listing optimization, TikTok growth, email, and more — plus a free one-on-one Zoom call.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="https://www.emapdf.com/" target="_blank" rel="noopener noreferrer"
              style={{ background: '#01c61f', color: '#fff', padding: '14px 28px', borderRadius: '9999px', fontWeight: 700, fontSize: '15px', textDecoration: 'none' }}>
              Get the Free Ecom Profit Box
            </a>
            <a href="https://calendly.com/evolvemedia/amz-30-min" target="_blank" rel="noopener noreferrer"
              style={{ background: '#6aa7f0', color: '#fff', padding: '14px 28px', borderRadius: '9999px', fontWeight: 700, fontSize: '15px', textDecoration: 'none' }}>
              Book a Free Strategy Call
            </a>
          </div>
        </div>
      </div>
    </div>
    </BlogLayout>
  );
}
